var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptimization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4635_1525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.829 14.5003C120.024 14.5003 121 13.5248 121 12.3302C121 11.1355 120.024 10.1601 118.829 10.1601H110.956V2.17011C110.956 0.975453 109.991 0 108.785 0C107.579 0 106.614 0.975453 106.614 2.17011V10.171H93.6092C84.1024 3.92373 72.7206 0.295924 60.4945 0.295924C48.2684 0.295924 36.8866 3.92373 27.3799 10.171H14.3753V2.17011C14.3753 0.975453 13.3994 0 12.2042 0C11.009 0 10.0331 0.975453 10.0331 2.17011V10.171H2.17109C0.975895 10.171 0 11.1465 0 12.3411C0 13.5358 0.975895 14.5112 2.17109 14.5112H10.044V27.488C3.772 37.0014 0.120616 48.4 0.120616 60.6425C0.120616 72.885 3.772 84.2835 10.044 93.8079V106.741H2.17109C0.975895 106.741 0 107.716 0 108.911C0 110.106 0.975895 111.081 2.17109 111.081H10.044V118.775C10.044 119.97 11.0199 120.945 12.2151 120.945C13.4103 120.945 14.3862 119.97 14.3862 118.775V111.081H27.3251C36.8428 117.35 48.2465 121 60.5055 121C72.7645 121 84.1572 117.35 93.6859 111.081H106.625V118.775C106.625 119.97 107.601 120.945 108.796 120.945C109.991 120.945 110.967 119.97 110.967 118.775V111.081H118.84C120.035 111.081 121.011 110.106 121.011 108.911C121.011 107.716 120.035 106.741 118.84 106.741H110.967V93.8079C117.239 84.2945 120.89 72.8959 120.89 60.6425C120.89 48.389 117.239 37.0014 110.967 27.4771V14.5003H118.84H118.829ZM60.4945 4.62518C69.0692 4.62518 77.3479 6.54321 84.848 10.1601H36.141C43.6411 6.53225 51.9198 4.62518 60.4945 4.62518ZM92.2934 14.5003C95.0675 16.4183 97.6882 18.5994 100.122 21.0325C102.535 23.4438 104.706 26.0523 106.614 28.7923V92.4817C104.706 95.2327 102.535 97.8303 100.122 100.241C97.7101 102.653 95.1004 104.823 92.3591 106.73H28.6409C25.8886 104.823 23.2899 102.653 20.8776 100.241C18.4653 97.8303 16.2942 95.2217 14.3862 92.4817V28.8033C16.2942 26.0523 18.4653 23.4547 20.8776 21.0435C23.2899 18.6322 25.9325 16.4293 28.7067 14.5112H92.3043L92.2934 14.5003ZM14.3753 14.5003H21.5684C18.9696 16.6923 16.5683 19.0926 14.3753 21.6901V14.5003ZM4.4628 60.6425C4.4628 52.0388 6.39266 43.731 10.044 36.2123V85.0726C6.39266 77.554 4.4628 69.2462 4.4628 60.6425ZM14.3753 106.741V99.5948C16.5573 102.17 18.9477 104.56 21.5245 106.741H14.3753ZM60.4945 116.66C51.8869 116.66 43.5754 114.731 36.0533 111.081H84.9467C77.4247 114.731 69.1131 116.66 60.5055 116.66H60.4945ZM106.614 106.741H99.4645C102.041 104.56 104.432 102.17 106.614 99.5948V106.741ZM116.537 60.6425C116.537 69.2462 114.607 77.554 110.956 85.0726V36.2123C114.607 43.731 116.537 52.0388 116.537 60.6425ZM106.614 21.6901C104.421 19.1035 102.008 16.6923 99.4207 14.5003H106.614V21.6901Z",
    fill: "#A52EB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1019 37.0563H71.2617V49.8906H84.1019V37.0563Z",
    fill: "#A52EB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.283 37.0563H88.4453V49.8906H102.283V37.0563Z",
    fill: "#A52EB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9202 18.8843H54.0801V32.716H66.9202V18.8843Z",
    fill: "#A52EB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.283 54.2308H88.4453V67.0651H102.283V54.2308Z",
    fill: "#A52EB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1019 18.8843H71.2617V32.716H84.1019V18.8843Z",
    fill: "#A52EB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9202 37.0563H54.0801V49.8906H66.9202V37.0563Z",
    fill: "#A52EB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1019 54.2308H71.2617V67.0651H84.1019V54.2308Z",
    fill: "#A52EB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5548 54.2308H18.7168V67.0651H32.5548V54.2308Z",
    fill: "#A52EB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9202 54.2308H54.0801V67.0651H66.9202V54.2308Z",
    fill: "#A52EB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9202 71.4053H54.0801V84.2397H66.9202V71.4053Z",
    fill: "#A52EB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7386 37.0563H36.8984V49.8906H49.7386V37.0563Z",
    fill: "#A52EB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7386 54.2308H36.8984V67.0651H49.7386V54.2308Z",
    fill: "#A52EB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7386 18.8843H36.8984V32.716H49.7386V18.8843Z",
    fill: "#A52EB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7168 32.716H32.5548V18.8843H30.0218C27.8836 20.4516 25.8441 22.1943 23.9362 24.1014C22.0283 26.0084 20.2848 28.047 18.7168 30.1842V32.716Z",
    fill: "#A52EB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.283 30.1842C100.715 28.047 98.9718 26.0084 97.0639 24.1014C95.156 22.1943 93.1164 20.4516 90.9783 18.8843H88.4453V32.716H102.283V30.1842Z",
    fill: "#A52EB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.283 71.4053H88.4453V84.2397H102.283V71.4053Z",
    fill: "#A52EB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0639 97.1946C98.9718 95.2875 100.715 93.2489 102.283 91.1117V88.5799H88.4453V102.412H90.9783C93.1164 100.844 95.156 99.1016 97.0639 97.1946Z",
    fill: "#A52EB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7168 91.1007C20.2848 93.238 22.0283 95.2765 23.9362 97.1836C25.8441 99.0907 27.8836 100.833 30.0218 102.401H32.5548V88.5689H18.7168V91.1007Z",
    fill: "#A52EB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1019 71.4053H71.2617V84.2397H84.1019V71.4053Z",
    fill: "#A52EB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1019 88.5689H71.2617V102.401H84.1019V88.5689Z",
    fill: "#A52EB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5548 71.4053H18.7168V84.2397H32.5548V71.4053Z",
    fill: "#A52EB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7386 71.4053H36.8984V84.2397H49.7386V71.4053Z",
    fill: "#A52EB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5548 37.0563H18.7168V49.8906H32.5548V37.0563Z",
    fill: "#A52EB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7386 88.5689H36.8984V102.401H49.7386V88.5689Z",
    fill: "#A52EB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9202 88.5689H54.0801V102.401H66.9202V88.5689Z",
    fill: "#A52EB1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4635_1525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 121,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimization);
export default __webpack_public_path__ + "static/media/optimization.b77578897b368e432460925b1d63972c.svg";
export { ForwardRef as ReactComponent };